<div class="column-item-card">
  <div class="box" [ngClass]="{disabled: config.metadatas.disabled}">
    <div class="box-header flex-between w-100">
      <div class="header-text flex-center-x-y">
        <i class="fa fa-sm fa-grip-vertical"></i>
        <h3 class="p-b-0 p-l-sm">
          <ng-container *ngFor="let transIds of config.path; let i = index">
            <ng-container *ngIf="i !== 0">
              {{ transIdsDisplay(transIds) }},
            </ng-container>
          </ng-container>
          <strong>{{ transIdsDisplay(config.transIds) }}</strong>
        </h3>
      </div>
      <div class="header-controls pull-right flex">
        <button type="button"
                class="btn lter"
                [tooltip]="isSortingDisabled() ? isFileType() ? ('TOOLTIPS.sorting_unavailable_for_file_type_fields' | translate): ('TOOLTIPS.sorting_unavailable_for_multiple_type_fields' | translate) : ''"
                [disabled]="isSortingDisabled()"
                [attr.test-id]="'sort-direction-btn' | gpTestId: 'column-item'"
                (click)="changeSortDirection()">
          <i class="fa fa-light fa-arrow-down-arrow-up" aria-hidden="true"
             [class.fa-arrow-down-short-wide]="config.fieldSortedBy.toLowerCase() === 'asc'"
             [class.fa-arrow-up-wide-short]="config.fieldSortedBy.toLowerCase() === 'desc'"></i>
        </button>
        <button type="button"
                class="btn lter"
                [attr.test-id]="'sort-order-btn' | gpTestId: 'column-item'"
                *ngIf="isOrderVisible()"
                [disabled]="config.metadatas.disabled"
                (click)="increaseSortOrder()">
          {{ config.fieldSortPosition || '' }}
        </button>
        <button type="button"
                class="btn lter"
                [disabled]="config.metadatas.disabled"
                [attr.test-id]="'remove-column-btn' | gpTestId: 'column-item'"
                (click)="removeColumn()">
          <i class="fa fa-light fa-trash-can" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div *ngIf="isEntityType()" class="box-footer p-y-sm">
      <div>
        <label class="ui-switch v-m">
          <input type="checkbox" [(ngModel)]="config.displayEntityPath"
                 (ngModelChange)="initDisplayEntityPathInConfig(config?.field)">
          <em></em>
        </label>
        {{ 'REPORTS.display_entity_path' | translate }}
      </div>
    </div>
    <div class="m-t-md m-l-xs" *ngIf="hasPayValue() && config.isRetro">
      <div class="checkbox retro-checkbox"
           [attr.test-id]="'display-retro-checkbox' | gpTestId: 'column-item': config.field">
        <input type="checkbox"
               [disabled]="config.metadatas.disabled"
               class="retro-input"
               [id]="'column-item-retro-checkbox-' + config.field"
               [(ngModel)]="config.displayRetro">
      </div>
      <label [for]="'column-item-retro-checkbox-' + config.field"
             class="pointer">
        {{ 'REPORTS.display_retro' | translate }}
      </label>
    </div>
  </div>
</div>
